import React from "react";
import Banner from "../../Section/Home/Banner/banner";
import Desktop from "../../Media/FnB_Desktop.webp";
import Mobile from "../../Media/FnB_Mobile.webp";
import About from "../../Section/Detail/about/about";
import Promo from "../../Section/Home/Promo/promo";
import Lokasi from "../../Section/Home/Lokasi/lokasi";
import fnb from "./fnb.json";
import Produk from "./FnB1/FnB1";

const Fnb = () => {
  return (
    <div>
      <Banner Desktop={Desktop} Mobile={Mobile} />
      <About poin={fnb.point} judul={fnb.judul} Deskrisi={fnb.deskripsi} />
      <Promo />
      <Produk />
      <Lokasi />
    </div>
  );
};

export default Fnb;
